/**
 * @generated SignedSource<<40d390cdf0b14a22df4fba36c9cf0f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TreeConfigEditor_TreeNodeFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AdvertisementForm_TreeNodeFragment" | "ProjectAdvertisementForm_TreeNodeFragment" | "RewardTreeConfigEditor_TreeNodeFragment" | "ShowAnswerTreeConfigEditor_TreeNodeFragment" | "StartTreeConfigEditor_TreeNodeFragment" | "VisibilityTreeConfigEditor_TreeNodeFragment">;
  readonly " $fragmentType": "TreeConfigEditor_TreeNodeFragment";
};
export type TreeConfigEditor_TreeNodeFragment$key = {
  readonly " $data"?: TreeConfigEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TreeConfigEditor_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TreeConfigEditor_TreeNodeFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RewardTreeConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShowAnswerTreeConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StartTreeConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VisibilityTreeConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdvertisementForm_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectAdvertisementForm_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "e119ecc7648fe8aed0b97e690d0cb26c";

export default node;
